
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/[slug]",
      function () {
        return require("private-next-pages/features/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/[slug]"])
      });
    }
  